//Principais
import { Component, HostListener, inject, OnInit, OnDestroy, TemplateRef, ViewChild, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from "rxjs";
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { BaseComponent } from 'components/base/base.component';
import { CardArquivoAnexadoComponent } from 'components/card-arquivo-anexado/card-arquivo-anexado.component';
import { VisualizarArquivoComponent } from 'components/visualizar-arquivo/visualizar-arquivo.component';
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { AtribuicaoLoginSed, UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { DefaultResponse } from 'src/app/shared/models/DefaultResponse';
import { EscolaService } from 'src/app/shared/services/escola.service';
import { SubCategoria } from 'src/app/shared/models/categoria/SubCategoria';
import { CategoriaService } from 'src/app/shared/services/categoria.service';
import { PlanoMelhoriaAcao } from "src/app/shared/models/plano-melhoria/planoMelhoriaAcao";
import { PlanoMelhoria } from 'src/app/shared/models/plano-melhoria/planoMelhoria';
import { PlanoMelhoriaValidacao } from 'src/app/shared/models/plano-melhoria/planoMelhoriaValidacao';
import { PlanoMelhoriaService } from 'src/app/shared/services/plano-melhoria.service';
import { ParametroPeriodoService } from 'src/app/shared/services/parametro-periodo.service';
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
import { CodigoParametroPeriodo } from 'src/app/shared/enums/ParametroPeriodo/CodigoParametroPeriodo';
declare const jsPDF: any;
@Component({
  selector: 'app-plano-melhoria-cadastro',
  templateUrl: './plano-melhoria-cadastro.component.html',
  styleUrls: ['./plano-melhoria-cadastro.component.scss'],
  standalone: true,
  imports: [angularCommonImports, libsCommonImports, convivaCommonImports, CardArquivoAnexadoComponent, VisualizarArquivoComponent]
})
export class PlanoMelhoriaCadastroComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  // Aciona a pesquisa de planos conforme o filtro selecionado
  public OnPesquisar() {
    this.PesquisarPlanos();
  }

  @Input() planoMelhoria: PlanoMelhoria | null = null;
  @Input() ehModal = false;
  @Input() ehEdicao = false;
  @Input() codigoEscolaFiltroModal: number | null = null;
  @Input() codigoDiretoriaFiltroModal: number | null = null;
  @Output() fechar = new EventEmitter<void>();
  @Output() planoAtualizado = new EventEmitter<PlanoMelhoria>();

  //Injeções
  // private escolaService = inject(EscolaService);
  private categoriaService = inject(CategoriaService);
  private config = inject(NgSelectConfig);
  // private spinnerService = inject(NgxSpinnerService);
  // private authService = inject(AuthService);
  // private toastr = inject(ToastrService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  private planoMelhoriaService = inject(PlanoMelhoriaService);
  private ParametroPeriodoService = inject(ParametroPeriodoService);
  private route = inject(ActivatedRoute);

  // public userLogado: UserLoginSed | null;
  // public atribuicoesLogin: AtribuicaoLoginSed;
  public planoSelecionado: PlanoMelhoria | null = null;
  public lstAcoes: PlanoMelhoriaAcao[] = [];
  public lstPlanosMelhoria: PlanoMelhoria[] = [];
  public showCadastroModal = false;
  public ehReadOnly = false;
  public ehEdit = false;
  // public colunasGrid = this.definirColunasGrid();
  public legendaEvidenciasGrid = `
    <div class="legenda-evidencias" aria-label="Legenda de evidências">
      <strong>Legenda - Evidências:</strong>
      <span><span class="bolinha-evidencia nenhuma"></span>Nenhuma</span>
      <span><span class="bolinha-evidencia parcial"></span>Parcial</span>
      <span><span class="bolinha-evidencia completo"></span>Completo</span>
    </div>
  `;
  public colunasGridPMCE = this.definirColunasGridPMCE();
  public showModalExcluirPlano = false;
  public planoIdParaExcluir = 0;

  public showModalEnviarPlanoValidacao = false;
  public planoIdParaValidacao = 0;
  public anoModal = "";
  public escolaModal = "";
  public descricaoModal = "";
  public codigoEscolaModalSelecionada: number | null = null;
  public codigoDiretoriaModalSelecionada: number | null = null;

  showModalDeletarArquivo = false;
  codigoArquivoRemover?: number;
  showModalVisualizarArquivo = false;
  arquivoVisualizando?: ArquivoAzure;
  arquivoRemover?: ArquivoAzure;
  acaoIndexAtual?: number; // Para controlar qual ação está sendo editada no contexto de arquivo
  tamanhoInicialAcoes: number = 0; // Rastreia o tamanho inicial das ações carregadas


  // constructor() {
  //   this.config.notFoundText = "Não encontrado";

  //   this.userLogado = this.authService.getUser();

  //   if (this.userLogado != null) {
  //     this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
  //   }
  // }

  @ViewChild('modalContent') modalContent!: TemplateRef<any>;


  public showModal = false;
  public submitted = false;
  public submittedModal = false;
  public qtdeCaracteresMetas: number = 0;
  public qtdeCaracteresDesafios: number = 0;
  //public qtdeCaracteresTemas: number = 0;
  public qtdeCaracteresAcao: number = 0;
  public qtdeCaracteresResponsavel: number = 0;
  public qtdeCaracteresTemaAcao: number[] = [];

  private inicializarContadoresTemaAcao() {
    this.qtdeCaracteresTemaAcao = [];
    const acoesArray = this.acoesFormArray;
    for (let i = 0; i < acoesArray.length; i++) {
      const acaoGroup = acoesArray.at(i) as FormGroup;
      const descricao = acaoGroup.get('dsTemaAcao')?.value;
      this.qtdeCaracteresTemaAcao[i] = descricao ? descricao.length : 0;
    }
  }

  // Atualiza a contagem de caracteres do campo Tema e descrição da ação
  public OnChangeCountLettersTemaAcao(index: number) {
    const acoesArray = this.acoesFormArray;
    const acaoGroup = acoesArray.at(index) as FormGroup;
    const descricao = acaoGroup.get('dsTemaAcao')?.value;
    this.qtdeCaracteresTemaAcao[index] = descricao ? descricao.length : 0;
  }

  // Removido: não faz sentido para FormArray
  // public qtdeCaracteresPublico: number = 0;
  public qtdeCaracteresRecurso: number = 0;
  public qtdeCaracteresParceria: number = 0;
  public qtdeCaracteresOutraParceria: number = 0;
  public formularioLiberado: boolean = false;
  public mensagemBloqueio: string | null = null;
  public evidenciaLiberada: boolean = false;
  public mensagemBloqueioEvidencia: string | null = null;
  public arquivosEvidenciaPendentes: { [codigoAcao: number]: File[] } = {};
  public arquivosEvidenciaRemovidos: { [codigoAcao: number]: ArquivoAzure[] } = {};

  @Input() tituloAcaoModal: string = '';
  @Input() statusPlano?: number;

  arquivoService = inject(ArquivoService);

  private get deveValidarPeriodoParaSalvar(): boolean {
    return this.tituloAcaoModal === 'Cadastrar plano' || this.tituloAcaoModal === 'Editar plano' || this.ehEdicao;
  }



  // public diretorias: Diretoria[] = [];
  // public escolas: Escola[] = [];
  public subCategoriasComMaisOcorrencias: SubCategoria[] = [];
  public bimestres = [
    { id: 1, name: '1º Bimestre' },
    { id: 2, name: '2º Bimestre' },
    { id: 3, name: '3º Bimestre' },
    { id: 4, name: '4º Bimestre' },
  ];

  public publico = [
    { id: 1, name: 'Estudantes' },
    { id: 2, name: 'Professores' },
    { id: 3, name: 'Equipe gestora' },
    { id: 4, name: 'Outros servidores/funcionários' },
    { id: 5, name: 'Famílias e responsáveis' },
    { id: 6, name: 'Equipe de apoio escolar (AOE)' },

  ];
  public formCadastrar!: FormGroup;
  public formModal!: FormGroup;

  public get form() {
    return this.formCadastrar.controls;
  }

  public get modalForm() {
    return this.formModal.controls;
  }

  // DADOS GERAIS
  public get codigoDiretoria() {
    return this.formCadastrar.get('codigoDiretoria')!;
  }
  public get codigoEscola() {
    return this.formCadastrar.get('codigoEscola')!;
  }
  public get codigoPlanoMelhoria() {
    return this.formCadastrar.get('codigoPlanoMelhoria')!;
  }
  public get ano() {
    return this.formCadastrar.get('ano')!;
  }
  public get dsMetas() {
    return this.formCadastrar.get('dsMetas')!;
  }
  public get dsDesafios() {
    return this.formCadastrar.get('dsDesafios')!;
  }
  // public get dsTemas() {
  //   return this.formCadastrar.get('dsTemas')!;
  // }

  // DADOS MODAL
  public get codigoAcao() {
    return this.formModal.get('codigoAcao')!;
  }
  public get dsAcao() {
    return this.formModal.get('dsAcao')!;
  }
  public get dsResponsavel() {
    return this.formModal.get('dsResponsavel')!;
  }
  public get dsTemaAcao() {
    return this.formModal.get('dsTemaAcao')!;
  }
  public get dsPublico() {
    return this.formModal.get('dsPublico')!;
  }
  public get dsRecurso() {
    return this.formModal.get('dsRecurso')!;
  }
  public get dsParceria() {
    return this.formModal.get('dsParceria')!;
  }
  public get dsOutraParceria() {
    return this.formModal.get('dsOutraParceria')!;
  }
  public get dataAcao() {
    return this.formModal.get('dataAcao')!;
  }
  public get nrBimestre() {
    return this.formModal.get('nrBimestre')!;
  }
  public get codigoPlanoAcao() {
    return this.formModal.get('codigoPlanoAcao')!;
  }


  public files: ArquivoAzure[] = [];
  public NaoPodeAlterar = false;

  public showModalAprovarPlano = false;
  public showModalDevolverPlano = false;
  public planoIdParaAprovacao = 0;
  public qtdeCaracteresJustificativaPec = 0;
  public formValidacaoPec!: FormGroup;


  get acoesFormArray(): FormArray {
    if (!this.formModal) {
      this.formModal = new FormGroup({
        acoes: new FormArray([])
      });
    }

    if (!this.formModal.get('acoes')) {
      this.formModal.addControl('acoes', new FormArray([]));
    }

    return this.formModal.get('acoes') as FormArray;



  }



  public async ngOnInit() {
    this.ehReadOnly = this.statusPlano === 4;
    setTimeout(() => this.inicializarContadoresTemaAcao());

    this.formCadastrar = new FormGroup({
      codigoDiretoria: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required]),
      codigoEscola: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required]),
      codigoPlanoMelhoria: new FormControl(0),
      ano: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.min(2025), Validators.max(2099), Validators.pattern(/^\d{0,4}$/),]),
      dsMetas: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
      dsDesafios: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
      //dsTemas: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
      cienciaResponsaveis: new FormControl(false, [Validators.requiredTrue]),
    });

    this.formValidacaoPec = new FormGroup({
      dsJustificativa: new FormControl(null, [Validators.required, Validators.minLength(150), Validators.maxLength(1000)]),
    });

    if (this.ehModal && this.tituloAcaoModal === 'Cadastrar plano') {
      if (this.codigoDiretoriaFiltroModal) {
        this.formCadastrar.get('codigoDiretoria')?.setValue(this.codigoDiretoriaFiltroModal);
      }
      if (this.codigoEscolaFiltroModal) {
        this.formCadastrar.get('codigoEscola')?.setValue(this.codigoEscolaFiltroModal);
      }
    }

    // this.formModal = new FormGroup({
    //   codigoAcao: new FormControl(0),
    //   dsAcao: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dsResponsavel: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dsTemaAcao: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dsPublico: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dsRecurso: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dsParceria: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dsOutraParceria: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
    //   dataAcao: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required]),
    //   nrBimestre: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required]),
    //   codigoPlanoAcao: new FormControl(0),
    // });

    // Evita operações pesadas quando o componente é usado como modal dentro de si mesmo
    if (!this.ehModal) {
      this.spinnerService.show();

      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        this.getDiretorias();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        this.getDiretoriasPerfilDiretoria();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
        this.getDiretoriasPerfilEscola();
      }

      this.PreencherFormulario();
      this.PesquisarPlanos();

      this.NaoPodeAlterar = (this.atribuicoesLogin.NomePerfil.toUpperCase().includes("PEC") || this.atribuicoesLogin.NomePerfil.toUpperCase().includes("SUPERVISOR"));

      await this.validarPeriodoLiberacaoPMCE();
      await this.validarPeriodoLiberacaoEvidenciasPMCE();

      // Verifica se deve abrir o modal automaticamente (navegação da tela de consulta)
      this.route.queryParams.subscribe((params: any) => {
        if (params['openModal'] === 'true') {
          setTimeout(() => this.OnOpenModal(), 100);
          // Remove o query param da URL
          this.router.navigate([], { relativeTo: this.route, queryParams: {} });
        }
      });
    } else {
      // Quando é modal, apenas preencher o formulário se houver dados
      if (this.deveValidarPeriodoParaSalvar) {
        await this.validarPeriodoLiberacaoPMCE();
      }

      await this.validarPeriodoLiberacaoEvidenciasPMCE();
      this.PreencherFormulario();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ehEdicao)
      this.ehReadOnly = false;
    else if (this.ehModal && this.planoMelhoria)
      this.ehReadOnly = true;

    if (changes['planoMelhoria']?.currentValue) {
      this.formModal = new FormGroup({
        acoes: new FormArray([])
      });
      this.carregarPlanoNoFormulario(changes['planoMelhoria'].currentValue);
      setTimeout(() => this.inicializarContadoresTemaAcao());
    }
  }

  ngOnDestroy(): void {
    // Reset component state to prevent stale data on next instantiation
    this.tituloAcaoModal = '';
    this.statusPlano = undefined;
    this.planoSelecionado = null;
    this.showCadastroModal = false;
    this.showModalExcluirPlano = false;
    this.showModalEnviarPlanoValidacao = false;
    this.showModalAprovarPlano = false;
    this.showModalDevolverPlano = false;
    this.showModalDeletarArquivo = false;
    this.showModalVisualizarArquivo = false;
    this.ehReadOnly = false;
    this.ehEdit = false;
  }

  private setupAcoesListener(): void {
    this.acoesFormArray.valueChanges.subscribe((acoes: any[]) => {
      this.statusPlano = 0;
    });
  }

  public podeExibirUploadEvidencia(index: number): boolean {
    if (!this.ehModal || !this.ehEdicao || !this.evidenciaLiberada) {
      return false;
    }

    const acaoGroup = this.acoesFormArray.at(index) as FormGroup | undefined;
    const codigoAcao = acaoGroup?.get('codigoPlanoMelhoriaAcao')?.value;
    return Number(codigoAcao) > 0;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.spinnerService.hide();
    }
  }


  acaoAbertaIndex: number | null = 0;

  toggleAcao(index: number): void {
    this.acaoAbertaIndex = this.acaoAbertaIndex === index ? null : index;
  }
  PreencherFormulario() {
    // this.colunasGrid = this.definirColunasGrid();
    if (!this.planoMelhoria)
      return;

    if (this.planoMelhoria) {
      this.formCadastrar.patchValue({
        cienciaResponsaveis: this.planoMelhoria.cienciaResponsaveis
      });
    }

    if (this.ehReadOnly) {
      this.formCadastrar.get('cienciaResponsaveis')?.setValue(true);
      this.formCadastrar.get('cienciaResponsaveis')?.disable();
    }

    this.formCadastrar.patchValue({
      codigoDiretoria: this.planoMelhoria.codigoDiretoria,
      codigoEscola: this.planoMelhoria.codigoEscola,
      codigoPlanoMelhoria: this.planoMelhoria.codigoPlanoMelhoria,
      ano: this.planoMelhoria.anoLetivo,
      dsMetas: this.planoMelhoria.meta,
      dsDesafios: this.planoMelhoria.desafio,
      //dsTemas: this.planoMelhoria.tema,
      acoes: new FormArray([]),


    });




    this.qtdeCaracteresMetas = this.planoMelhoria.meta ? this.planoMelhoria.meta.length : 0;
    this.qtdeCaracteresDesafios = this.planoMelhoria.desafio ? this.planoMelhoria.desafio.length : 0;
    //this.qtdeCaracteresTemas = this.planoMelhoria.tema ? this.planoMelhoria.tema.length : 0;

    this.lstAcoes = this.planoMelhoria.acoes ? [...this.planoMelhoria.acoes] : [];

    if (this.planoMelhoria.ocorrencia && this.subCategoriasComMaisOcorrencias.length === 0) {
      this.subCategoriasComMaisOcorrencias = this.planoMelhoria.ocorrencia.split(',').map((descricao, idx) => ({
        codigoSubCategoria: idx + 1,
        descricaoSubCategoria: descricao.trim(),
        codigoCategoria: 0
      }));
    }

    if (this.ehReadOnly) {
      this.ano.disable();
      this.dsMetas.disable();
      this.dsDesafios.disable();
      //this.dsTemas.disable();
    } else {
      this.ano.enable();
      this.dsMetas.enable();
      this.dsDesafios.enable();
      //this.dsTemas.enable();
    }
  }

  // public definirColunasGrid() {
  //   return [
  //     { field: 'codigoPlanoMelhoriaAcao', headerSort: false, visible: false },
  //     { title: 'Ação a ser <br>realizada', field: 'acao', width: 90, hozAlign: "center", headerHozAlign: "center", headerSort: false },
  //     { title: 'Responsável <br>pelo projeto', field: 'responsavel', width: 110, hozAlign: "center", headerHozAlign: "center", headerSort: false },
  //     { title: 'Temas a <br>serem <br>desenvolvidos', field: 'tema', width: 120, hozAlign: "center", headerHozAlign: "center", headerSort: false },
  //     { title: 'Público', field: 'publico', hozAlign: "center", width: 90, headerHozAlign: "center", headerSort: false },
  //     { title: 'Recursos<br>Necessários', field: 'recurso', width: 110, hozAlign: "center", headerHozAlign: "center", headerSort: false },
  //     { title: 'Parceria <br>com a rede <br>protetiva', field: 'parceria', width: 100, hozAlign: "center", headerHozAlign: "center", headerSort: false },
  //     { title: 'Outras <br>parcerias', field: 'outraParceria', width: 100, hozAlign: "center", headerHozAlign: "center", headerSort: false },
  //     { title: 'Data', field: 'dataAcao', hozAlign: "center", width: 90, headerHozAlign: "center", headerSort: false, formatter: "datetime", formatterParams: { inputFormat: "iso", outputFormat: "dd/MM/yyyy", } },
  //     { title: 'Bimestre', field: 'bimestre', hozAlign: "center", width: 90, headerHozAlign: "center", headerSort: false },
  //     {
  //       title: '', field: 'visualizar', visible: !this.ehReadOnly, width: 90, hozAlign: "center", headerHozAlign: "center", headerSort: false, formatter: function (cell: any, formatterParams: any, onRendered: any) {
  //         return `
  //         <div style='display:inline-flex;gap:0.4em;'>
  //           <i class="fa-solid fa-edit" aria-hidden="true"></i>
  //         </div>
  //         <div class="ps-4" style='display:inline-flex;gap:0.4em;'>
  //           <i class="fa-solid fa-trash" aria-hidden="true"></i>
  //         </div>
  //         `;
  //       }, cellClick: (e: any, cell: any) => this.OnClickAcao(e, cell)
  //     }
  //   ]
  // }


  public definirColunasGridPMCE() {
    return [
      { title: 'Ano', field: 'anoLetivo', width: 80, hozAlign: "center", headerHozAlign: "center", headerFilter: "input" },
      { title: 'Escola', field: 'nomeEscola', hozAlign: "center", headerHozAlign: "center", headerFilter: "input",
 },
      {
        title: 'Status',
        field: 'statusDescricao',
        hozAlign: "center",
        headerHozAlign: "center",
        headerFilter: "input",
        formatter: (cell: any) => {
          const data = cell.getRow().getData();
          const status = data.status;

          let cor = '#999';

          switch (status) {
            case 0: // Novo
              cor = '#006ebd';
              break;
            case 1: // Aguardando Validação Supervisor de Ensino
            case 2: // Aguardando Validação PEC CONVIVA
              cor = '#f57e3a';
              break;
            case 3: // Devolvido para ajustes
              cor = '#cb2525';
              break;
            case 4: // Aprovado
              cor = '#1fce7c';
              break;
          }

          return `
            <div style="
              display: inline-flex;
              align-items: center;
              gap: 8px;
              justify-content: center;
            ">
              <span style="
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: ${cor};
                display: inline-block;
              "></span>
              <span style="font-size: 1.2rem;">
              ${cell.getValue()}</span>
            </div>
          `;
        }
      },
      {
        title: 'Evidências',
        field: 'statusEvidencias',
        minWidth: 120,
        hozAlign: "center",
        headerHozAlign: "center",
        headerSort: false,
        formatter: (cell: any) => this.formatarStatusEvidencias(cell.getRow().getData())
      },
      {
        title: 'Ações', field: 'visualizar', width: 110, hozAlign: "center", headerHozAlign: "center", headerSort: false, cssClass: "col-acoes", formatter: (cell: any, formatterParams: any, onRendered: any) => {
          const data = cell.getRow().getData();
          const status = data.status;

          if (this.NaoPodeAlterar) {
            const ehSupervisor = this.atribuicoesLogin.NomePerfil.toUpperCase().includes("SUPERVISOR");
            const ehPec = this.atribuicoesLogin.NomePerfil.toUpperCase().includes("PEC");
            const podeProcedimento = (ehSupervisor && status === 1) || (ehPec && status === 2);

            let html = `
              <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                flex-wrap: nowrap;
                white-space: nowrap;
              ">
                <i class="fa-solid fa-eye" title="Visualizar"></i>
            `;
            if (podeProcedimento) {
              html += `<i class="fa-solid fa-check-square" title="Aprovar"></i>`;
              html += `<i class="fa-solid fa-times" title="Devolver para ajustes"></i>`;
            }
            html += `</div>`;
            return html;
          }

          let html = `
            <div style="
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 10px;
              flex-wrap: nowrap;
              white-space: nowrap;
            ">
              <i class="fa-solid fa-eye" title="Visualizar"></i>
              <i class="fa-solid fa-edit" title="Editar"></i>
          `;

          if (status !== 1 && status !== 2 && status !== 4) {
            html += `<i class="fa-solid fa-arrows-rotate" title="Enviar para a Validação"></i>`;
          }

          if (status !== 4) {
            html += `<i class="fa-solid fa-trash" title="Excluir"></i>`;
          }

          html += `</div>`;

          return html;
        },
        cellClick: (e: any, cell: any) => this.OnClickAcaoPMCE(e, cell)

      }
    ]
  }

  private obterResumoEvidencias(plano: PlanoMelhoria): { totalAcoes: number; totalAcoesComArquivo: number; cor: string; valor: string; texto: string } {
    const totalAcoes = Number(plano.quantidadeAcoes ?? 0);
    const totalAcoesComArquivo = Number(plano.quantidadeAcoesComArquivo ?? 0);

    let cor = '#b8b8b8';
    if (totalAcoesComArquivo > 0 && totalAcoesComArquivo < totalAcoes) {
      cor = '#f57e3a';
    } else if (totalAcoes > 0 && totalAcoesComArquivo >= totalAcoes) {
      cor = '#1fce7c';
    }

    return {
      totalAcoes,
      totalAcoesComArquivo,
      cor,
      valor: `${totalAcoesComArquivo}/${totalAcoes} ações`,
      texto: `${totalAcoesComArquivo} ações com evidência de ${totalAcoes} ações`
    };
  }

  private formatarStatusEvidencias(plano: PlanoMelhoria): string {
    const resumo = this.obterResumoEvidencias(plano);
    return `
      <div title="${resumo.texto}" style="display: inline-flex; align-items: center; gap: 8px; justify-content: center;">
        <span style="width: 10px; height: 10px; border-radius: 50%; background-color: ${resumo.cor}; display: inline-block; flex-shrink: 0;"></span>
        <span style="font-size: 1.2rem;">${resumo.valor}</span>
      </div>
    `;
  }

  private prepararPlanosGrid(planos: PlanoMelhoria[]): PlanoMelhoria[] {
    return planos.map((plano) => {
      const resumo = this.obterResumoEvidencias(plano);
      return {
        ...plano,
        statusEvidencias: resumo.valor
      };
    });
  }

  public OnPlanoEvidenciasAtualizado(planoAtualizado: PlanoMelhoria): void {
    const [planoGrid] = this.prepararPlanosGrid([planoAtualizado]);
    this.lstPlanosMelhoria = this.lstPlanosMelhoria.map((plano) =>
      Number(plano.codigoPlanoMelhoria) === Number(planoGrid.codigoPlanoMelhoria)
        ? planoGrid
        : plano
    );
    this.planoSelecionado = planoGrid;
  }

  public async OnSalvar() {
    if (!this.formularioLiberado && this.deveValidarPeriodoParaSalvar) {
      await this.validarPeriodoLiberacaoPMCE();
    }

    if (!this.formularioLiberado) {
      this.toastr.warning('Formulário bloqueado — fora do período permitido ou perfil não autorizado.');
      return;
    }
    this.submitted = true;

    if (!this.formCadastrar.get('cienciaResponsaveis')?.value) {
      this.toastr.error('Todos os envolvidos devem estar cientes para continuar.');
      return;
    }

    this.spinnerService.show();

    // Marca todos os campos como touched para exibir erros de validação
    this.formCadastrar.markAllAsTouched();

    if (this.formCadastrar.invalid) {
      this.spinnerService.hide();
      this.toastr.error('Existem campos obrigatórios não preenchidos. Verifique o formulário.');
      return;
    }

    // Validação explícita do FormArray de ações
    let acoesInvalidas = false;
    const acoesArray = this.acoesFormArray;
    for (let i = 0; i < acoesArray.length; i++) {
      const acaoGroup = acoesArray.at(i) as FormGroup;
      if (acaoGroup.invalid) {
        acoesInvalidas = true;
        acaoGroup.markAllAsTouched();
      }
    }
    if (acoesInvalidas) {
      this.toastr.error('Todas as ações devem ter o campo "Tema e descrição da ação" preenchido com no mínimo 300 caracteres.');
      this.spinnerService.hide();
      return;
    }

    this.lstAcoes = this.acoesFormArray.value.map((a: any) => {
      const arquivos = a.arquivos || [];
      const quantidadeArquivos = a.quantidadeArquivos ?? arquivos.length;
      const outraParceria = a.dsOutraParceria || '';
      const acao = {
        codigoPlanoMelhoriaAcao: a.codigoPlanoMelhoriaAcao || 0,
        acao: a.dsAcao || '',
        responsavel: a.dsResponsavel || '',
        tema: a.dsTemaAcao || '',
        publico: a.dsPublico || 0,
        recurso: a.dsRecurso || '',
        parceria: a.dsParceria || outraParceria || '',
        outraParceria,
        dataAcao: a.dataAcao ? new Date(a.dataAcao) : new Date(),
        bimestre: a.nrBimestre || 0,
        codigoPlanoMelhoria: this.codigoPlanoMelhoria?.value || 0,
        quantidadeArquivos,
        possuiArquivo: a.possuiArquivo ?? quantidadeArquivos > 0,
        arquivos
      } as PlanoMelhoriaAcao;
      return acao;
    });

    if (this.lstAcoes.length < 4) {
      this.toastr.error('É necessário adicionar ao menos 4 (quatro) ações para o plano da melhoria de convivência escolar.');
      this.spinnerService.hide();
      return;
    }

    const codigoDiretoriaSelecionada = this.codigoDiretoria?.value || this.codigoDiretoriaFiltroModal || this.userLogado?.codigoDiretoria;
    let dir = this.diretorias.filter(r => r.codigoDiretoria == codigoDiretoriaSelecionada)[0];

    if (!dir && codigoDiretoriaSelecionada) {
      const usuarioDiretoria = this.userLogado?.DadosUsuario?.find((u: AtribuicaoLoginSed) => u.CodigoDiretoria === codigoDiretoriaSelecionada);
      if (usuarioDiretoria) {
        dir = {
          codigoDiretoria: codigoDiretoriaSelecionada,
          nomeDiretoria: usuarioDiretoria.NomeDiretoria,
        } as Diretoria;
      }
    }

    const codigoEscolaSelecionada = this.codigoEscola?.value || this.codigoEscolaFiltroModal || this.userLogado?.codigoEscola;
    let esc = this.escolas.filter(r => r.codigoEscola == codigoEscolaSelecionada)[0];

    if (!esc && codigoEscolaSelecionada) {
      const usuarioEscola = this.userLogado?.DadosUsuario?.find((u: AtribuicaoLoginSed) => u.CodigoEscola === codigoEscolaSelecionada);
      if (usuarioEscola) {
        esc = {
          codigoEscola: codigoEscolaSelecionada,
          nomeEscola: usuarioEscola.NomeEscola,
        } as Escola;
      }
    }

    if (!esc) {
      this.toastr.error('Selecione uma escola válida para salvar o plano.');
      this.spinnerService.hide();
      return;
    }

    if (!dir) {
      this.toastr.error('Selecione uma diretoria válida para salvar o plano.');
      this.spinnerService.hide();
      return;
    }

    //OBTER STATUS ATUAL DO PLANO
    const statusAtual = this.statusPlano;

    const objetoPlanoMelhoria: PlanoMelhoria = {
      codigoPlanoMelhoria: this.codigoPlanoMelhoria?.value,
      codigoDiretoria: dir.codigoDiretoria,
      nomeDiretoria: dir.nomeDiretoria,
      codigoEscola: esc.codigoEscola,
      nomeEscola: esc.nomeEscola,
      anoLetivo: this.ano?.value,
      meta: this.dsMetas?.value,
      desafio: this.dsDesafios?.value,
      cienciaResponsaveis: this.formCadastrar.get('cienciaResponsaveis')?.value,
      //tema: this.dsTemas?.value,
      //arquivos: this.files,
      ocorrencia: '',
      status: statusAtual !== undefined ? statusAtual : 0,
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      nomeUsuario: this.userLogado?.nome,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      email: this.atribuicoesLogin.Email,
      acoes: [],
    };

    if (this.lstAcoes.length > 0)
      objetoPlanoMelhoria.acoes.push(...this.lstAcoes);

    let result: DefaultResponse;

    if (objetoPlanoMelhoria.codigoPlanoMelhoria == 0) {
      result = await lastValueFrom(this.planoMelhoriaService.setCadastrarPlanoMelhoria(objetoPlanoMelhoria))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.spinnerService.hide();
      this.toastr.success('Plano de Melhoria de Convivência Escolar cadastrado com sucesso.');

    } else {
      result = await lastValueFrom(this.planoMelhoriaService.setAtualizarPlanoMelhoria(objetoPlanoMelhoria))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.spinnerService.hide();
      this.toastr.success('Plano de Melhoria de Convivência Escolar atualizado com sucesso.');
    }

    // Close modal and let parent component refresh data
    if (this.ehModal) {
      this.fechar.emit();
    } else {
      // Reload data for standalone page
      this.OnLimpar();
      await this.PesquisarPlanos();
      this.PreencherFormulario();
    }
  }

  public OnAdicionarAcao() {
    this.submittedModal = true;
    this.spinnerService.show();

    // Validação explícita do FormArray de ações
    let acoesInvalidas = false;
    const acoesArray = this.acoesFormArray;
    for (let i = 0; i < acoesArray.length; i++) {
      const acaoGroup = acoesArray.at(i) as FormGroup;
      if (acaoGroup.invalid) {
        acoesInvalidas = true;
        acaoGroup.markAllAsTouched();
      }
    }
    if (this.formModal.invalid || acoesInvalidas) {
      this.spinnerService.hide();
      return;
    }

    const outraParceriaModal = this.formModal.get('dsOutraParceria')?.value || '';
    const acao: PlanoMelhoriaAcao = {
      codigoPlanoMelhoriaAcao: this.formModal.get('codigoAcao')?.value != '0' ? this.formModal.get('codigoAcao')?.value : this.lstAcoes.length + 1,
      acao: this.formModal.get('dsAcao')?.value,
      responsavel: this.formModal.get('dsResponsavel')?.value,
      tema: this.formModal.get('dsTemaAcao')?.value,
      publico: this.formModal.get('dsPublico')?.value,
      recurso: this.formModal.get('dsRecurso')?.value,
      parceria: this.formModal.get('dsParceria')?.value || outraParceriaModal,
      outraParceria: outraParceriaModal,
      dataAcao: this.formModal.get('dataAcao')?.value,
      bimestre: this.formModal.get('nrBimestre')?.value,
      codigoPlanoMelhoria: this.formModal.get('codigoPlanoAcao')?.value,
      quantidadeArquivos: 0,
      possuiArquivo: false,
      arquivos: []
    };

    const idx = this.lstAcoes.findIndex(x => x.codigoPlanoMelhoriaAcao === acao.codigoPlanoMelhoriaAcao);

    if (idx >= 0) {
      this.lstAcoes[idx] = acao;
      this.lstAcoes = [...this.lstAcoes];
      this.toastr.success("Ação atualizada com sucesso");
    } else {
      this.lstAcoes = [...this.lstAcoes, acao];
      this.toastr.success("Ação inserida com sucesso");
    }

    // Reset status do plano para 0 quando ações são adicionadas ou atualizadas
    this.statusPlano = 0;

    this.spinnerService.hide();

    this.FecharModal();
  }

  public OnLimpar() {
    this.form.codigoPlanoMelhoria.setValue(0);
    this.form.ano.setValue(null);
    this.form.dsMetas.setValue(null);
    this.form.dsDesafios.setValue(null);
    //this.form.dsTemas.setValue(null);
    this.lstAcoes = []

    this.qtdeCaracteresMetas = 0;
    this.qtdeCaracteresDesafios = 0;
    //this.qtdeCaracteresTemas = 0;
  }

  public OnLimparModal() {
    this.modalForm.codigoAcao.setValue(0);
    this.modalForm.dsAcao.setValue(null);
    this.modalForm.dsResponsavel.setValue(null);
    this.modalForm.dsTemaAcao.setValue(null);
    this.modalForm.dsPublico.setValue(null);
    this.modalForm.dsRecurso.setValue(null);
    this.modalForm.dsParceria.setValue(null);
    this.modalForm.dsOutraParceria.setValue(null);
    this.modalForm.dataAcao.setValue(null);
    this.modalForm.nrBimestre.setValue(null);
    this.modalForm.codigoPlanoAcao.setValue(0);

    this.qtdeCaracteresAcao = 0;
    this.qtdeCaracteresResponsavel = 0;
    this.qtdeCaracteresTemaAcao = [];
    // this.qtdeCaracteresPublico = 0;
    this.qtdeCaracteresRecurso = 0;
    this.qtdeCaracteresParceria = 0;
    this.qtdeCaracteresOutraParceria = 0;
  }

  public OnCadastrarAcao() {
    this.submittedModal = false;

    this.acoesFormArray.push(
      new FormGroup({
        codigoPlanoMelhoriaAcao: new FormControl(0),
        dsAcao: new FormControl(''),
        dsResponsavel: new FormControl(''),
        dsTemaAcao: new FormControl('', [Validators.required, Validators.minLength(300), Validators.maxLength(2000)]),
        dsPublico: new FormControl(null),
        dsRecurso: new FormControl(''),
        dsParceria: new FormControl(''),
        dsOutraParceria: new FormControl(''),
        dataAcao: new FormControl(null),
        nrBimestre: new FormControl(null),
        quantidadeArquivos: new FormControl(0),
        possuiArquivo: new FormControl(false),
        arquivos: new FormControl([])
      })
    );
    // Inicializa a contagem de caracteres para a nova ação
    const novoIndex = this.acoesFormArray.length - 1;
    this.qtdeCaracteresTemaAcao[novoIndex] = 0;
    this.acaoAbertaIndex = novoIndex;
  }


  private OnClickAcao(e: any, cell: any) {
    const row = cell.getRow().getData();
    const target = e.target;

    if (target.classList.contains('fa-edit')) {
      this.OnEditarAcao(row);
    }

    if (target.classList.contains('fa-trash')) {
      this.lstAcoes = this.lstAcoes.filter(x => x.codigoPlanoMelhoriaAcao !== row.codigoPlanoMelhoriaAcao);
      this.toastr.success('Ação removida com sucesso');
    }
  }

  private OnClickAcaoPMCE(e: any, cell: any) {
    const row = cell.getRow().getData();
    const target = e.target;
    const idPlano = row.codigoPlanoMelhoria;
    const statusPlano = row.status;
    const anoPlano = row.anoLetivo;
    const escolaPlano = row.nomeEscola;

    if (target.classList.contains('fa-eye')) {
      this.ehEdit = false;
      this.ehReadOnly = true;
      this.showCadastroModal = true;
      this.planoSelecionado = row;
      this.tituloAcaoModal = 'Visualizar plano';
      this.statusPlano = statusPlano;
    }

    if (target.classList.contains('fa-edit')) {
      this.ehEdit = true;
      this.ehReadOnly = statusPlano === 4;
      this.planoSelecionado = row;
      this.tituloAcaoModal = 'Editar plano';
      this.statusPlano = statusPlano;
      this.showCadastroModal = true;

      if (statusPlano === 4) {

        this.formCadastrar.get('ano')?.disable();
        this.formCadastrar.get('dsMetas')?.disable();
        this.formCadastrar.get('dsDesafios')?.disable();

      }

    }

    if (target.classList.contains('fa-arrows-rotate')) {
      this.OnValidarPlanoMelhoria(idPlano, anoPlano, escolaPlano)
    }

    if (target.classList.contains('fa-trash')) {
      this.OnExcluirPMCE(idPlano, anoPlano, escolaPlano)
    }

    if (target.classList.contains('fa-check-square')) {
      this.planoSelecionado = row;
      this.showModalAprovarPlano = true;
    }

    if (target.classList.contains('fa-times')) {
      this.planoSelecionado = row;
      this.qtdeCaracteresJustificativaPec = 0;
      this.formValidacaoPec?.get('dsJustificativa')?.setValue(null);
      this.showModalDevolverPlano = true;
    }
  }

  private carregarPlanoNoFormulario(plano: any): void {

    if (!this.acoesFormArray) {
      return;
    }

    this.acoesFormArray.clear();

    plano.acoes?.forEach((acao: any) => {
      const quantidadeArquivos = acao.quantidadeArquivos ?? (acao.arquivos?.length ?? 0);
      const possuiArquivo = acao.possuiArquivo ?? quantidadeArquivos > 0;
      const arquivos = (acao.arquivos || []).map((arquivo: any) => ({
        ...arquivo,
        dataOperacao: this.getDataOperacaoArquivo(arquivo)
      }));

      this.acoesFormArray?.push(
        new FormGroup({
          codigoPlanoMelhoriaAcao: new FormControl(acao.codigoPlanoMelhoriaAcao || 0),
          dsAcao: new FormControl(acao.acao),
          dsResponsavel: new FormControl(acao.responsavel || ''),
          dsTemaAcao: new FormControl(acao.tema, [Validators.required, Validators.minLength(300), Validators.maxLength(2000)]),
          dsPublico: new FormControl(this.toSelectId(acao.publico, 6)),
          dsRecurso: new FormControl(acao.recurso),
          dsParceria: new FormControl(acao.parceria || ''),
          dsOutraParceria: new FormControl(acao.outraParceria || acao.parceria || ''),
          dataAcao: new FormControl(this.formatDateToInput(acao.dataAcao)),
          nrBimestre: new FormControl(this.toSelectId(acao.bimestre, 4)),
          quantidadeArquivos: new FormControl(quantidadeArquivos),
          possuiArquivo: new FormControl(possuiArquivo),
          arquivos: new FormControl(arquivos)
        })
      );
    });

    // Guardar tamanho inicial das ações carregadas
    this.tamanhoInicialAcoes = this.acoesFormArray.length;

    this.acaoAbertaIndex = 0;

    // Monitorar mudanças nas ações
    this.setupAcoesListener();
  }

  private atualizarResumoEvidenciasPlano(): void {
    if (!this.planoMelhoria) {
      return;
    }

    const acoes = this.planoMelhoria.acoes || [];
    const quantidadeAcoes = acoes.length;
    const quantidadeAcoesComArquivo = acoes.filter((acao) => {
      const quantidadeArquivos = acao.quantidadeArquivos ?? acao.arquivos?.length ?? 0;
      return acao.possuiArquivo ?? quantidadeArquivos > 0;
    }).length;

    this.planoMelhoria.quantidadeAcoes = quantidadeAcoes;
    this.planoMelhoria.quantidadeAcoesComArquivo = quantidadeAcoesComArquivo;
    this.planoMelhoria.statusEvidencias = `${quantidadeAcoesComArquivo}/${quantidadeAcoes} ações`;
  }




  public FecharModalExclusao() {
    this.showModalExcluirPlano = false;
    this.planoIdParaExcluir = 0;
    this.anoModal = "";
    this.escolaModal = "";
    this.descricaoModal = "";
  }

  public OnExcluirPMCE(idPlano: number, anoPlano: number, escolaPlano: string) {
    this.planoIdParaExcluir = idPlano;
    this.anoModal = String(anoPlano);
    this.escolaModal = escolaPlano;
    this.showModalExcluirPlano = true;
    this.descricaoModal = "Tem certeza de que deseja excluir o plano?";
  }


  public async DeletePlano() {
    const dir = this.diretorias.filter(r => r.codigoDiretoria == this.codigoDiretoria?.value)[0];
    const esc = this.escolas.filter(r => r.codigoEscola == this.codigoEscola?.value)[0];

    const objetoPlanoMelhoria: PlanoMelhoria = {
      codigoPlanoMelhoria: this.planoIdParaExcluir!,
      codigoDiretoria: this.codigoDiretoria?.value,
      nomeDiretoria: dir.nomeDiretoria,
      codigoEscola: esc.codigoEscola,
      nomeEscola: esc.nomeEscola,
      anoLetivo: this.ano?.value,
      meta: this.dsMetas?.value,
      desafio: this.dsDesafios?.value,
      cienciaResponsaveis: false,
      //arquivos: this.files,
      //tema: this.dsTemas?.value,
      ocorrencia: '',
      status: 0,
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      nomeUsuario: this.userLogado?.nome,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      email: this.atribuicoesLogin.Email,
      acoes: [],
    };

    this.spinnerService.show();

    try {
      const result: DefaultResponse = await lastValueFrom(
        this.planoMelhoriaService.setDeletePlanoMelhoria(objetoPlanoMelhoria)
      );

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.toastr.success('Plano excluido com sucesso!');
    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }


    this.spinnerService.hide();
    this.toastr.success('Plano de Melhoria de Convivência Escolar excluido com sucesso.'); this.toastr.success('Ação removida com sucesso');

    this.FecharModalExclusao();
    window.location.reload();
  }




  private OnEditarAcao(acao: PlanoMelhoriaAcao): any[] {
    this.submittedModal = false;
    this.OnLimparModal();
    const dataFormatada = this.formatDateToInput(acao.dataAcao);

    const acaoFormatada = {

      codigoAcao: acao.codigoPlanoMelhoriaAcao,
      dsAcao: acao.acao,
      dsResponsavel: acao.responsavel || '',
      dsTemaAcao: acao.tema,
      dsPublico: this.toSelectId(acao.publico, 6),
      dsRecurso: acao.recurso,
      dsParceria: acao.parceria || '',
      dsOutraParceria: acao.outraParceria || acao.parceria || '',
      dataAcao: dataFormatada,
      nrBimestre: this.toSelectId(acao.bimestre, 4),
      codigoPlanoAcao: acao.codigoPlanoMelhoria,
    };

    return [acaoFormatada];

  }

  public async PesquisarPlanos() {
    const result = await lastValueFrom(this.planoMelhoriaService.getPlanoMelhoriaPorDiretoriaEEscola(this.codigoDiretoria?.value, this.codigoEscola?.value))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.lstPlanosMelhoria = result.data ? this.prepararPlanosGrid(result.data) : [];
  }

  // public async getSubCategoriasComMaisOcorrencias() {
  //   var ano: number = this.ano?.value;
  //   var codigoEscola: number = this.codigoEscola?.value;

  //   this.spinnerService.show();
  //   const result = await lastValueFrom(this.categoriaService.getSubCategoriasComMaisOcorrencias(ano, codigoEscola))
  //     .catch((err) => {
  //       return this.ConvivaErrors.handleResultError(err);
  //     });

  //   if (!result.isSucess) {
  //     this.toastr.error(result.message, result.title);
  //     this.spinnerService.hide();
  //     return;
  //   }

  //   this.subCategoriasComMaisOcorrencias = result.data;

  //   this.spinnerService.hide();
  // }

  public async getDiretorias() {
    this.spinnerService.show();
    const result = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.diretorias = result.data;
    this.spinnerService.hide();
    if (this.userLogado?.codigoDiretoria != undefined) {
      this.ativaDiretoria();
      this.getEscolas(true);
    }
  }

  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];
    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);
    });

    this.spinnerService.hide();

    if (this.diretorias.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      this.getEscolas(true);
    } else {
      this.ativaDiretoria();
      this.getEscolas(true);
    }
  }

  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
    });

    if (this.diretorias.length == 1 && this.escolas.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();

      if (!this.form.codigoEscola.value) {
        this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      }
      this.form.codigoEscola.disable();
    }

    if (this.diretorias.length == 1 && this.escolas.length > 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    }
    this.ativaDiretoria();
    if (!this.form.codigoEscola.value) {
      this.ativaEscola();
    }
    this.spinnerService.hide();
  }

  public async getEscolas(diretoriaLogada: boolean = false) {
    const codigoDE = this.userLogado?.codigoDiretoria != undefined && diretoriaLogada ? this.userLogado?.codigoDiretoria : this.formCadastrar.get('codigoDiretoria')?.value;
    if (this.atribuicoesLogin.NumeroComportamento == 1 || this.atribuicoesLogin.NumeroComportamento == 2) {
      const codigoEscolaSelecionadaAntes = this.formCadastrar.get('codigoEscola')?.value || this.codigoEscolaFiltroModal;
      this.zerarEscola();
      if (codigoDE != null) {
        this.spinnerService.show();
        const result = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        if (!result.isSucess) {
          this.toastr.error(result.message, result.title);
          this.spinnerService.hide();
          return;
        }
        this.escolas = result.data;
        this.spinnerService.hide();

        const escolaSelecionadaExisteNaLista = this.escolas.some((e: Escola) => e.codigoEscola == codigoEscolaSelecionadaAntes);
        if (codigoEscolaSelecionadaAntes && escolaSelecionadaExisteNaLista) {
          this.formCadastrar.get('codigoEscola')?.setValue(codigoEscolaSelecionadaAntes);
        } else {
          this.ativaEscola();
        }
      }
      this.spinnerService.hide();
    }
    if (this.userLogado !== null) {
      this.userLogado.codigoDiretoria = codigoDE == null ? 0 : codigoDE;
      this.authService.setUser(this.userLogado);
    }
  }

  public FecharCadastroModal() {
    this.showCadastroModal = false;
    this.planoSelecionado = null;
    this.statusPlano = undefined;
  }


  public zerarEscola() {
    this.escolas = [];
    this.formCadastrar.get('codigoEscola')?.patchValue(null);
  }

  public ativaEscola() {
    const codigoEscolaAtual = this.formCadastrar.get('codigoEscola')?.value;
    if (!codigoEscolaAtual && this.userLogado?.codigoEscola != undefined)
      this.formCadastrar.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola);
    if (this.userLogado !== null)
      this.authService.setUser(this.userLogado);
  }

  public ativaDiretoria() {
    if (this.userLogado?.codigoDiretoria != undefined)
      this.formCadastrar.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);
    if (this.userLogado !== null)
      this.authService.setUser(this.userLogado);
  }

  public FecharModal() {
    this.showModal = false;
    this.OnLimparModal();
  }

  private formatDateToInput(date: string | Date): string {
    if (!date) return '';
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /** Converte valor da API para id do ng-select (1..max). 0/null/inválido → null. */
  private toSelectId(value: unknown, max: number): number | null {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1 || n > max) {
      return null;
    }
    return n;
  }

  private getDataOperacaoArquivo(arquivo: any): Date | undefined {
    const data = arquivo.dataOperacao ?? arquivo.DataInclusao ?? arquivo.dataInclusao;

    if (!data) {
      return undefined;
    }

    if (data instanceof Date) {
      return data;
    }

    if (typeof data === 'string') {
      const dataTratada = data.trim();
      const dataBr = dataTratada.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);

      if (dataBr) {
        const [, dia, mes, ano, hora = '0', minuto = '0', segundo = '0'] = dataBr;
        return new Date(Number(ano), Number(mes) - 1, Number(dia), Number(hora), Number(minuto), Number(segundo));
      }

      const dataConvertida = new Date(dataTratada);
      return isNaN(dataConvertida.getTime()) ? undefined : dataConvertida;
    }

    const dataConvertida = new Date(data);
    return isNaN(dataConvertida.getTime()) ? undefined : dataConvertida;
  }

  OnChangeCountLettersMetas() {
    const descricao = this.formCadastrar.get('dsMetas')!.value;
    if (descricao != null)
      this.qtdeCaracteresMetas = descricao.length;
  }

  OnChangeCountLettersDesafios() {
    const descricao = this.formCadastrar.get('dsDesafios')!.value;
    if (descricao != null)
      this.qtdeCaracteresDesafios = descricao.length;
  }

  // OnChangeCountLettersTemas() {
  //   const descricao = this.formCadastrar.get('dsTemas')!.value;
  //   if (descricao != null)
  //     this.qtdeCaracteresTemas = descricao.length;
  // }

  OnChangeCountLettersAcao() {
    const descricao = this.formModal.get('dsAcao')!.value;
    if (descricao != null)
      this.qtdeCaracteresAcao = descricao.length;
  }

  OnChangeCountLettersResponsavel() {
    const descricao = this.formModal.get('dsResponsavel')!.value;
    if (descricao != null)
      this.qtdeCaracteresResponsavel = descricao.length;
  }



  // OnChangeCountLettersPublico() {
  //   const descricao = this.formModal.get('dsPublico')!.value;
  //   if (descricao != null)
  //     this.qtdeCaracteresPublico = descricao.length;
  // }

  OnChangeCountLettersRecurso() {
    const descricao = this.formModal.get('dsRecurso')!.value;
    if (descricao != null)
      this.qtdeCaracteresRecurso = descricao.length;
  }

  OnChangeCountLettersParceria() {
    const descricao = this.formModal.get('dsParceria')!.value;
    if (descricao != null)
      this.qtdeCaracteresParceria = descricao.length;
  }

  OnChangeCountLettersOutraParceria(index?: number) {
    const control = index == null
      ? this.formModal.get('dsOutraParceria')
      : (this.acoesFormArray.at(index) as FormGroup)?.get('dsOutraParceria');
    const descricao = control?.value;
    if (descricao != null)
      this.qtdeCaracteresOutraParceria = descricao.length;
  }

  private async validarPeriodoLiberacaoPMCE() {
    try {
      const response = await lastValueFrom(this.ParametroPeriodoService.getAllParametroPeriodo());
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }

      const parametros = response.data.filter(
        (p: any) => p.codigoPlano === CodigoParametroPeriodo.PMCE && p.flAtivo
      );

      const hoje = new Date();
      const dentroDoPeriodo = parametros.some((p: any) => {
        const inicio = new Date(p.dtInicio);
        const fim = new Date(p.dtFim);
        return hoje >= inicio && hoje <= fim;
      });

      this.formularioLiberado = dentroDoPeriodo;

      if (!this.formularioLiberado) {
        if (!dentroDoPeriodo) {
          this.mensagemBloqueio = 'Fora do período de preenchimento do Plano de Melhoria.';
        }
      }

    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    }
  }

  private async validarPeriodoLiberacaoEvidenciasPMCE() {
    try {
      const response = await lastValueFrom(this.ParametroPeriodoService.getAllParametroPeriodo());
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }

      const parametros = response.data.filter(
        (p: any) => p.codigoPlano === CodigoParametroPeriodo.EvidenciaPMCE && p.flAtivo
      );

      const hoje = new Date();
      const dentroDoPeriodo = parametros.some((p: any) => {
        const inicio = new Date(p.dtInicio);
        const fim = new Date(p.dtFim);
        return hoje >= inicio && hoje <= fim;
      });

      this.evidenciaLiberada = dentroDoPeriodo;
      this.mensagemBloqueioEvidencia = dentroDoPeriodo
        ? null
        : 'Fora do período de envio de evidências.';

    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    }
  }

  OnOpenModal() {
    this.ehEdit = true;
    this.planoSelecionado = null;
    this.statusPlano = undefined;
    this.codigoDiretoriaModalSelecionada = this.formCadastrar.get('codigoDiretoria')?.value || null;
    this.codigoEscolaModalSelecionada = this.formCadastrar.get('codigoEscola')?.value || null;
    this.showCadastroModal = true;
    //this.planoSelecionado = row;
    this.tituloAcaoModal = 'Cadastrar plano';
    //this.statusPlano = null;

    // Regra: recarregar escolas conforme filtro ou usuário logado usando getEscolas
    const codigoEscolaFiltro = this.formCadastrar.get('codigoEscola')?.value;
    if (codigoEscolaFiltro) {
      // Se houver escola no filtro, apenas seleciona ela no formulário após carregar todas
      this.codigoEscola?.setValue(codigoEscolaFiltro);
    }

  }

  public FecharModalEnviarValidacao() {
    this.showModalEnviarPlanoValidacao = false;
    this.planoIdParaValidacao = 0;
    this.anoModal = '';
    this.escolaModal = '';
    this.descricaoModal = "";
  }

  public FecharModalAprovar() {
    this.showModalAprovarPlano = false;
    this.planoSelecionado = null;
  }

  public async ConfirmarAprovacaoPlano() {
    if (!this.planoSelecionado) return;

    this.spinnerService.show();

    let status = 0;
    const perfil = this.atribuicoesLogin.NomePerfil.toUpperCase();
    if (perfil.includes("SUPERVISOR")) {
      status = 2;
    } else if (perfil.includes("PEC")) {
      status = 4;
    } else {
      this.toastr.error('Você não tem permissão para aprovar este plano.');
      this.spinnerService.hide();
      return;
    }

    const payload: PlanoMelhoriaValidacao = {
      codigoPlanoMelhoria: this.planoSelecionado.codigoPlanoMelhoria,
      justificativa: '',
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      nomeUsuario: this.userLogado?.nome,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      status: status,
    };

    try {
      const result: DefaultResponse = await lastValueFrom(this.planoMelhoriaService.setAprovarPlanoMelhoria(payload));
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        return;
      }
      this.toastr.success('Plano de Melhoria de Convivência Escolar aprovado com sucesso.');
      this.FecharModalAprovar();
      this.PesquisarPlanos();
    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  public FecharModalDevolver() {
    this.showModalDevolverPlano = false;
    this.planoSelecionado = null;
    this.formValidacaoPec?.get('dsJustificativa')?.setValue(null);
  }

  public async ConfirmarReprovacaoPlano() {
    if (!this.planoSelecionado) return;

    this.submitted = true;
    if (this.formValidacaoPec.invalid) {
      return;
    }

    this.spinnerService.show();

    const payload: PlanoMelhoriaValidacao = {
      codigoPlanoMelhoria: this.planoSelecionado.codigoPlanoMelhoria,
      justificativa: this.formValidacaoPec.get('dsJustificativa')?.value,
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      nomeUsuario: this.userLogado?.nome,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
    };

    try {
      const result: DefaultResponse = await lastValueFrom(this.planoMelhoriaService.setReprovarPlanoMelhoria(payload));
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        return;
      }
      this.toastr.success('Plano de Melhoria de Convivência Escolar reprovado com sucesso.');
      this.FecharModalDevolver();
      this.PesquisarPlanos();
    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  public OnChangeCountLettersJustificativaPec() {
    const descricao = this.formValidacaoPec.get('dsJustificativa')?.value;
    this.qtdeCaracteresJustificativaPec = descricao ? descricao.length : 0;
  }

  public OnValidarPlanoMelhoria(idPlano: number, anoPlano: number, escolaPlano: string) {
    this.planoIdParaValidacao = idPlano;
    this.anoModal = String(anoPlano);
    this.escolaModal = escolaPlano;
    this.showModalEnviarPlanoValidacao = true;
    this.descricaoModal = "Tem certeza de que deseja enviar para validação?";
  }

  public async EnviarPlanoParaValidacao() {
    const dir = this.diretorias.filter(r => r.codigoDiretoria == this.codigoDiretoria?.value)[0];
    const esc = this.escolas.filter(r => r.codigoEscola == this.codigoEscola?.value)[0];

    const objetoPlanoMelhoria: PlanoMelhoria = {
      codigoPlanoMelhoria: this.planoIdParaValidacao!,
      codigoDiretoria: this.codigoDiretoria?.value,
      nomeDiretoria: dir.nomeDiretoria,
      codigoEscola: esc.codigoEscola,
      nomeEscola: esc.nomeEscola,
      anoLetivo: this.ano?.value,
      meta: this.dsMetas?.value,
      desafio: this.dsDesafios?.value,
      cienciaResponsaveis: false,
      //arquivos: this.files,
      //tema: this.dsTemas?.value,
      ocorrencia: '',
      status: 0,
      codigoUsuario: this.atribuicoesLogin.CodigoUsuario,
      nomeUsuario: this.userLogado?.nome,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      email: this.atribuicoesLogin.Email,
      acoes: [],
    };

    this.spinnerService.show();

    try {
      const result: DefaultResponse = await lastValueFrom(
        this.planoMelhoriaService.EnviarPlanoParaValidacao(objetoPlanoMelhoria)
      );

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.toastr.success('Plano enviado para validação do Supervisor de Ensino!');
    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }


    this.spinnerService.hide();
    this.toastr.success('Plano de Melhoria de Convivência Escolar excluido com sucesso.'); this.toastr.success('Ação removida com sucesso');

    this.FecharModalExclusao();
    window.location.reload();
  }

  limitarAno(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.value) return;

    if (input.value.length > 4) {
      input.value = input.value.slice(0, 4);
      this.formCadastrar.get('ano')?.setValue(input.value);
    }
  }

  public getArquivosAcao(acaoIndex: number): ArquivoAzure[] {
    if (acaoIndex >= 0 && acaoIndex < this.acoesFormArray.length) {
      const acaoControl = this.acoesFormArray.at(acaoIndex) as FormGroup;
      const arquivos = acaoControl.get('arquivos')?.value || [];

      return arquivos;
    }

    return [];
  }

  private getCodigoAcaoPorIndex(acaoIndex: number): number {
    const acaoControl = this.acoesFormArray.at(acaoIndex) as FormGroup | undefined;
    return Number(acaoControl?.get('codigoPlanoMelhoriaAcao')?.value || 0);
  }

  public getArquivosEvidenciaPendentes(acaoIndex: number): File[] {
    const codigoAcao = this.getCodigoAcaoPorIndex(acaoIndex);
    return codigoAcao ? this.arquivosEvidenciaPendentes[codigoAcao] || [] : [];
  }

  public async SalvarEvidenciaAcao(acaoIndex: number) {
    await this.validarPeriodoLiberacaoEvidenciasPMCE();

    if (!this.podeExibirUploadEvidencia(acaoIndex)) {
      this.toastr.warning(this.mensagemBloqueioEvidencia ?? 'Envio de evidências indisponível.');
      return;
    }

    if (!this.planoMelhoria) {
      this.toastr.error('Plano não encontrado para salvar a evidência.');
      return;
    }

    const codigoAcao = this.getCodigoAcaoPorIndex(acaoIndex);

    if (!codigoAcao) {
      this.toastr.warning('A evidência só pode ser salva em ações já cadastradas.');
      return;
    }

    const arquivosPendentes = this.getArquivosEvidenciaPendentes(acaoIndex);
    if (arquivosPendentes.length === 0) {
      this.toastr.warning('Selecione ao menos um arquivo para salvar a evidência.');
      return;
    }

    const arquivosRemovidos = this.arquivosEvidenciaRemovidos[codigoAcao] || [];
    const formData = new FormData();
    formData.append('codigoPlanoMelhoria', String(this.planoMelhoria.codigoPlanoMelhoria));
    formData.append('codigoPlanoMelhoriaAcao', String(codigoAcao));
    formData.append('arquivosRemovidos', JSON.stringify(arquivosRemovidos));
    arquivosPendentes.forEach((arquivo) => formData.append('Files', arquivo, arquivo.name));

    this.spinnerService.show();
    try {
      const result = await lastValueFrom(this.planoMelhoriaService.setCadastrarEvidenciaPlanoMelhoriaAcao(formData))
        .catch((err) => this.ConvivaErrors.handleResultError(err));

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        return;
      }

      const arquivosSalvos = (result.data || []).map((arquivo: ArquivoAzure) => ({
        ...arquivo,
        dataOperacao: arquivo.dataOperacao || new Date(),
        nomeOriginal: arquivo.nomeOriginal || (arquivo.nome?.length > 37 ? arquivo.nome.substring(37) : arquivo.nome)
      }));

      if (arquivosSalvos.length > 0) {
        const acaoControl = this.acoesFormArray.at(acaoIndex) as FormGroup;
        const arquivosAtuais = acaoControl.get('arquivos')?.value || [];
        const novosArquivos = [...arquivosAtuais, ...arquivosSalvos];
        acaoControl.patchValue({
          arquivos: novosArquivos,
          quantidadeArquivos: novosArquivos.length,
          possuiArquivo: novosArquivos.length > 0
        }, { emitEvent: false });

        if (this.planoMelhoria.acoes) {
          this.planoMelhoria.acoes = this.planoMelhoria.acoes.map((acao) =>
            Number(acao.codigoPlanoMelhoriaAcao) === codigoAcao
              ? {
                ...acao,
                arquivos: novosArquivos,
                quantidadeArquivos: novosArquivos.length,
                possuiArquivo: novosArquivos.length > 0
              }
              : acao
          );
        }

        this.atualizarResumoEvidenciasPlano();
        this.planoAtualizado.emit({ ...this.planoMelhoria, acoes: [...(this.planoMelhoria.acoes || [])] });
      }

      delete this.arquivosEvidenciaPendentes[codigoAcao];
      delete this.arquivosEvidenciaRemovidos[codigoAcao];
      const fileInput = document.getElementById(`arquivos-${acaoIndex}`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      this.toastr.success('Evidência salva com sucesso.');
    } finally {
      this.spinnerService.hide();
    }
  }

  liberarEdicao() {
    this.ehReadOnly = false;
    this.ehEdicao = true;
    this.tituloAcaoModal = 'Editar plano';
    this.ano.enable();
    this.dsMetas.enable();
    this.dsDesafios.enable();

    this.formCadastrar.get('cienciaResponsaveis')?.enable();

  }

  public removeFile() {
    if (this.acaoIndexAtual !== undefined && this.acaoIndexAtual >= 0) {
      if (!this.podeExibirUploadEvidencia(this.acaoIndexAtual)) {
        this.toastr.warning(this.mensagemBloqueioEvidencia ?? 'Remoção de evidências indisponível.');
        this.FecharModalDeletarArquivo();
        return;
      }

      // Remove arquivo de uma ação específica
      const acaoControl = this.acoesFormArray.at(this.acaoIndexAtual) as FormGroup;
      const arquivos = acaoControl.get('arquivos')?.value || [];
      const arquivoRemovido = arquivos.splice(this.codigoArquivoRemover!, 1)[0] as ArquivoAzure | undefined;
      acaoControl.patchValue({
        arquivos,
        quantidadeArquivos: arquivos.length,
        possuiArquivo: arquivos.length > 0
      }, { emitEvent: false });

      const codigoAcao = this.getCodigoAcaoPorIndex(this.acaoIndexAtual);
      if (codigoAcao && arquivoRemovido) {
        this.arquivosEvidenciaRemovidos[codigoAcao] = [
          ...(this.arquivosEvidenciaRemovidos[codigoAcao] || []),
          arquivoRemovido
        ];
      }

      const fileInput = document.getElementById(`arquivos-${this.acaoIndexAtual}`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    } else {
      // Remove do array global (compatibilidade)
      this.files.splice(this.codigoArquivoRemover!, 1);

      const fileInput = document.getElementById('arquivos') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }

    this.FecharModalDeletarArquivo();
  }

  public FecharModalDeletarArquivo() {
    this.showModalDeletarArquivo = false;
    this.acaoIndexAtual = undefined;
  }
  public visualizarAquivo(index: number, acaoIndex?: number): void {
    let arquivo: ArquivoAzure | undefined;

    if (acaoIndex !== undefined && acaoIndex >= 0) {
      // Visualizar arquivo de uma ação específica
      const arquivos = this.getArquivosAcao(acaoIndex);
      if (index >= 0 && index < arquivos.length) {
        arquivo = arquivos[index];
      }
    } else {
      // Visualizar arquivo do array global (compatibilidade)
      if (index >= 0 && index < this.files.length) {
        arquivo = this.files[index];
      }
    }

    if (arquivo) {
      this.arquivoVisualizando = arquivo;
      this.showModalVisualizarArquivo = true;
    }
  }
  public fecharModalVisualizarArquivo(): void {
    this.showModalVisualizarArquivo = false;
    this.arquivoVisualizando = undefined;
  }


  public async DownloadArquivo(index: number, acaoIndex?: number) {
    let arquivo: ArquivoAzure | undefined;

    if (acaoIndex !== undefined && acaoIndex >= 0) {
      // Download arquivo de uma ação específica
      const arquivos = this.getArquivosAcao(acaoIndex);
      if (index >= 0 && index < arquivos.length) {
        arquivo = arquivos[index];
      }
    } else {
      // Download arquivo do array global (compatibilidade)
      if (index >= 0 && index < this.files.length) {
        arquivo = this.files[index];
      }
    }

    if (!arquivo) {
      this.toastr.error('Arquivo não encontrado');
      return;
    }

    this.spinnerService.show();
    try {
      const response = await lastValueFrom(this.arquivoService.getArquivoPorNome(arquivo.nome));

      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = arquivo.nomeOriginal || arquivo.nome;
      link.click();
      window.URL.revokeObjectURL(url);

      this.toastr.success('Arquivo baixado com sucesso!');
    } catch (error) {
      this.toastr.error('Erro ao baixar o arquivo');
    } finally {
      this.spinnerService.hide();
    }
  }

  public popupremoverarquivo(index: number, acaoIndex?: number) {
    this.spinnerService.show();
    this.showModalDeletarArquivo = true;
    this.spinnerService.hide();
    this.codigoArquivoRemover = index;
    this.acaoIndexAtual = acaoIndex;

    if (acaoIndex !== undefined && acaoIndex >= 0) {
      // Arquivo de uma ação específica
      const arquivos = this.getArquivosAcao(acaoIndex);
      this.arquivoRemover = arquivos[index];
    } else {
      // Arquivo do array global (compatibilidade)
      this.arquivoRemover = this.files[index];
    }
    return;
  }
  public async OnFileChange(event: any, acaoIndex?: number) {
    await this.validarPeriodoLiberacaoEvidenciasPMCE();

    if (acaoIndex === undefined || acaoIndex < 0 || !this.podeExibirUploadEvidencia(acaoIndex)) {
      event.target.value = '';
      this.toastr.warning(this.mensagemBloqueioEvidencia ?? 'Envio de evidências indisponível.');
      return;
    }

    const files = Array.from(event.target.files || []) as File[];
    if (files.length === 0) return;

    const maxFileSize = 31 * 1024 * 1024; // 30 MB
    const codigoAcao = this.getCodigoAcaoPorIndex(acaoIndex);

    for (const file of files) {
      const fileName = file.name.split('.')[0];

      if (fileName.length > 30) {
        event.target.value = '';
        this.toastr.warning('O nome do arquivo não pode ter mais de 30 caracteres.');
        return;
      }

      if (file.size > maxFileSize) {
        event.target.value = '';
        this.toastr.warning('O tamanho máximo do arquivo é 30 MB.');
        return;
      }

      if (file.type !== "image/jpg" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "application/pdf" &&
        file.type !== "application/ppt" &&
        file.type !== "application/pptx" &&
        file.type !== "application/potx" &&
        file.type !== "application/ppsx" &&
        file.type !== "application/odp" &&
        file.type !== "audio/mpeg" &&
        file.type !== "video/mp4"
      ) {
        event.target.value = '';
        this.toastr.warning('Só é possivel subir arquivos .jpg, .jpeg , .png, .pdf, .mp3 , .mp4, .ppt, .pptx, .potx e ppsx');
        return;
      }
    }

    this.arquivosEvidenciaPendentes[codigoAcao] = files;
    this.toastr.success('Arquivo selecionado. Clique em Salvar Evidência para concluir.');
  }

  public getTamanhoAcoes(): number {
    return this.acoesFormArray.length;
  }

  public getTotalAcoesCarregadas(): number {
    return this.tamanhoInicialAcoes;
  }

  public removerAcao(index: number): void {
    // Validar se pode remover: em modo de edição, não pode deixar vazio (deve ter pelo menos 1 ação)
    if (this.ehEdicao && this.acoesFormArray.length === 1) {
      this.toastr.warning('Não é possível remover a última ação em modo de edição');
      return;
    }
    this.acoesFormArray.removeAt(index);
  }

    /**
   * Gera e faz download do PDF do plano de melhoria
   */
  public gerarPDFPlano(): void {
    if (!this.planoMelhoria) {
      this.toastr.error('Nenhum plano disponível para download');
      return;
    }

    this.spinnerService.show();

    try {
      const jsPDFConstructor = (window as any).jspdf?.jsPDF || (window as any).jsPDF;

      if (!jsPDFConstructor) {
        throw new Error('jsPDF não está carregado. Verifique o index.html');
      }

      const doc = new jsPDFConstructor();

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;
      const maxWidth = pageWidth - (margin * 2);
      let yPosition = margin;

      // ========== HELPER: Verificar necessidade de nova página ==========
      const checkAndAddPage = (requiredSpace: number = 20): boolean => {
        if (yPosition + requiredSpace > pageHeight - margin) {
          doc.addPage();
          yPosition = margin;
          return true;
        }
        return false;
      };

      // ========== CABEÇALHO DO DOCUMENTO ==========
      doc.setFillColor(26, 122, 154);
      doc.rect(0, 0, pageWidth, 35, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('Plano de Melhoria de Convivencia Escolar - PMCE', pageWidth / 2, 15, { align: 'center' });

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const dataGeracao = new Date().toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
      doc.text(`Gerado em: ${dataGeracao}`, pageWidth / 2, 25, { align: 'center' });

      yPosition = 45;
      doc.setTextColor(0, 0, 0);

      // ========== SEÇÃO: INFORMAÇÕES DO PLANO ==========
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('INFORMACOES DO PLANO', margin + 2, yPosition + 6);
      yPosition += 12;

      // Status com indicador visual colorido
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Status:', margin, yPosition);

      const statusTexto = this.getStatusTexto(this.planoMelhoria.status || 0);
      const statusCor = this.getStatusColor(this.planoMelhoria.status || 0);

      // Desenhar círculo de status
      doc.setFillColor(statusCor[0], statusCor[1], statusCor[2]);
      doc.circle(margin + 20, yPosition - 2, 2, 'F');

      doc.setFont('helvetica', 'normal');
      doc.text(statusTexto, margin + 25, yPosition);
      yPosition += 10;

      // Tabela com informações básicas
      const infoData = [
        ['Ano Letivo', this.planoMelhoria.anoLetivo?.toString() || 'N/A'],
        ['URE (Diretoria)', this.planoMelhoria.nomeDiretoria || 'N/A'],
        ['Escola', this.planoMelhoria.nomeEscola || 'N/A'],
        ['Codigo do Plano', this.planoMelhoria.codigoPlanoMelhoria?.toString() || 'N/A']
      ];

      doc.autoTable({
        startY: yPosition,
        head: [],
        body: infoData,
        theme: 'grid',
        styles: {
          fontSize: 9,
          cellPadding: 3
        },
        columnStyles: {
          0: {
            fontStyle: 'bold',
            cellWidth: 45,
            fillColor: [245, 245, 245]
          },
          1: {
            cellWidth: maxWidth - 45
          }
        },
        margin: { left: margin, right: margin }
      });

      yPosition = doc.lastAutoTable.finalY + 12;

      // ========== SEÇÃO: MOTIVO DA REPROVAÇÃO (se aplicável) ==========
      if (this.planoMelhoria.status === 3 && this.planoMelhoria.justificativa) {
        checkAndAddPage(35);

        doc.setFillColor(255, 220, 220);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(203, 37, 37);
        doc.text('MOTIVO DA REPROVACAO', margin + 2, yPosition + 6);
        yPosition += 12;

        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);

        const justificativaLines = doc.splitTextToSize(this.planoMelhoria.justificativa, maxWidth - 4);
        justificativaLines.forEach((line: string) => {
          checkAndAddPage();
          doc.text(line, margin + 2, yPosition);
          yPosition += 5;
        });
        yPosition += 10;
      }

      // ========== SEÇÃO: DIAGNÓSTICO ==========
      checkAndAddPage(35);
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('DIAGNOSTICO (Dados da Plataforma Conviva)', margin + 2, yPosition + 6);
      yPosition += 12;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      const diagnosticoTexto = this.planoMelhoria.meta || 'Nao informado';
      const diagnosticoLines = doc.splitTextToSize(diagnosticoTexto, maxWidth - 4);

      diagnosticoLines.forEach((line: string) => {
        checkAndAddPage();
        doc.text(line, margin + 2, yPosition);
        yPosition += 5;
      });
      yPosition += 10;

      // ========== SEÇÃO: OBJETIVOS ==========
      checkAndAddPage(35);
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text('OBJETIVOS (Definicao clara do problema e resultado esperado)', margin + 2, yPosition + 6);
      yPosition += 12;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      const objetivosTexto = this.planoMelhoria.desafio || 'Nao informado';
      const objetivosLines = doc.splitTextToSize(objetivosTexto, maxWidth - 4);

      objetivosLines.forEach((line: string) => {
        checkAndAddPage();
        doc.text(line, margin + 2, yPosition);
        yPosition += 5;
      });
      yPosition += 10;

      // ========== SEÇÃO: AÇÕES DO PLANO ==========
      if (this.planoMelhoria.acoes && this.planoMelhoria.acoes.length > 0) {
        checkAndAddPage(45);

        doc.setFillColor(22, 122, 154);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(255, 255, 255);
        doc.text(`ACOES DO PLANO (${this.planoMelhoria.acoes.length} acoes cadastradas)`, margin + 2, yPosition + 6);
        yPosition += 15;
        doc.setTextColor(0, 0, 0);

        this.planoMelhoria.acoes.forEach((acao, index) => {
          checkAndAddPage(60);

          // Cabeçalho da ação
          doc.setFillColor(230, 230, 230);
          doc.rect(margin, yPosition, maxWidth, 7, 'F');
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.text(`Acao ${index + 1}`, margin + 2, yPosition + 5);
          yPosition += 10;

          // Montar dados da ação
          const acaoDataArray: string[][] = [];

          if (acao.tema) {
            acaoDataArray.push(['Tema e Descricao', acao.tema]);
          }

          const publicoNome = this.getPublicoNome(acao.publico || 0);
          acaoDataArray.push(['Publico', publicoNome]);

          if (acao.responsavel) {
            acaoDataArray.push(['Responsavel', acao.responsavel]);
          }

          if (acao.outraParceria) {
            acaoDataArray.push(['Parceria com Rede Protetiva', acao.outraParceria]);
          }

          const bimestreNome = this.getBimestreNome(acao.bimestre || 0);
          acaoDataArray.push(['Bimestre', bimestreNome]);

          const quantidadeArquivos = acao.quantidadeArquivos ?? (acao.arquivos?.length ?? 0);
          const possuiArquivo = acao.possuiArquivo ?? quantidadeArquivos > 0;
          const evidenciasTexto = possuiArquivo
            ? `${quantidadeArquivos} arquivo(s) anexado(s)`
            : 'Nenhuma evidencia anexada';
          acaoDataArray.push(['Evidencias', evidenciasTexto]);

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: acaoDataArray,
            theme: 'striped',
            styles: {
              fontSize: 8,
              cellPadding: 2.5
            },
            columnStyles: {
              0: {
                fontStyle: 'bold',
                cellWidth: 50,
                fillColor: [250, 250, 250]
              },
              1: {
                cellWidth: maxWidth - 50
              }
            },
            margin: { left: margin, right: margin }
          });

          yPosition = doc.lastAutoTable.finalY + 10;
        });
      } else {
        checkAndAddPage(20);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(128, 128, 128);
        doc.text('Nenhuma acao cadastrada no plano.', margin, yPosition);
        yPosition += 15;
        doc.setTextColor(0, 0, 0);
      }

      // ========== SEÇÃO: DECLARAÇÃO DE CIÊNCIA ==========
      if (this.planoMelhoria.cienciaResponsaveis) {
        checkAndAddPage(35);

        doc.setFillColor(240, 255, 240);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(31, 206, 124);
        doc.text('DECLARACAO DE CIENCIA DOS RESPONSAVEIS', margin + 2, yPosition + 6);
        yPosition += 12;

        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);

        const declaracao = 'Declaro, na qualidade de integrante da equipe gestora (diretor/vice) da Unidade Escolar, que todas as pessoas citadas como responsaveis neste plano foram devidamente informadas e estao cientes de suas atribuicoes, compromissos e responsabilidades no ambito das acoes previstas.';
        const declaracaoLines = doc.splitTextToSize(declaracao, maxWidth - 10);

        declaracaoLines.forEach((line: string) => {
          checkAndAddPage();
          doc.text(line, margin + 5, yPosition);
          yPosition += 4;
        });

        yPosition += 5;

        doc.setDrawColor(31, 206, 124);
        doc.setLineWidth(0.8);
        doc.rect(margin + 2, yPosition - 3, 4, 4);
        doc.setFillColor(31, 206, 124);
        doc.rect(margin + 2.5, yPosition - 2.5, 3, 3, 'F');

        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Confirmado', margin + 8, yPosition);
      }

      // ========== RODAPÉ EM TODAS AS PÁGINAS ==========
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.setFont('helvetica', 'normal');

        doc.text(
          `Pagina ${i} de ${totalPages}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: 'center' }
        );

        doc.text(
          'PMCE - Plano de Melhoria de Convivencia Escolar',
          margin,
          pageHeight - 10
        );

        doc.text(
          dataGeracao,
          pageWidth - margin,
          pageHeight - 10,
          { align: 'right' }
        );
      }

      // ========== SALVAR O ARQUIVO PDF ==========
      const escolaNome = this.planoMelhoria.nomeEscola?.replace(/[^a-zA-Z0-9]/g, '_') || 'Escola';
      const anoLetivo = this.planoMelhoria.anoLetivo || 'SemAno';
      const codigoPlano = this.planoMelhoria.codigoPlanoMelhoria || '0';
      const nomeArquivo = `PMCE_${escolaNome}_${anoLetivo}_ID${codigoPlano}.pdf`;

      doc.save(nomeArquivo);

      this.toastr.success('PDF gerado e baixado com sucesso!');

    } catch (error: any) {
      console.error('Erro ao gerar PDF:', error);
      console.error('Mensagem:', error.message);
      this.toastr.error(`Erro ao gerar o PDF: ${error.message || 'Erro desconhecido'}`);
    } finally {
      this.spinnerService.hide();
    }
  }
    /**
   * Retorna a cor RGB do status do plano
   */
  private getStatusColor(status: number): number[] {
    const statusColors: { [key: number]: number[] } = {
      0: [0, 110, 189],      // Novo - Azul
      1: [245, 126, 58],     // Aguardando Validação - Laranja
      2: [245, 126, 58],     // Aguardando Validação PEC - Laranja
      3: [203, 37, 37],      // Devolvido - Vermelho
      4: [31, 206, 124]      // Aprovado - Verde
    };
    return statusColors[status] || [153, 153, 153]; // Cinza como padrão
  }

  /**
   * Retorna o texto descritivo do status
   */
  private getStatusTexto(status: number): string {
    const statusMap: { [key: number]: string } = {
      0: 'Novo',
      1: 'Aguardando Validação Supervisor de Ensino',
      2: 'Aguardando Validação PEC CONVIVA',
      3: 'Devolvido para ajustes',
      4: 'Aprovado'
    };
    return statusMap[status] || 'Sem status';
  }

  /**
   * Formata a data para exibição
   */
  private formatarData(data: Date | string | undefined): string {
    if (!data) return 'N/A';
    try {
      const dataObj = typeof data === 'string' ? new Date(data) : data;
      return dataObj.toLocaleDateString('pt-BR');
    } catch {
      return 'N/A';
    }
  }

  /**
   * Retorna o nome do público baseado no ID
   */
  private getPublicoNome(publicoId: number): string {
    const publico = this.publico.find(p => p.id === publicoId);
    return publico ? publico.name : 'N/A';
  }

  /**
   * Retorna o nome do bimestre baseado no ID
   */
  private getBimestreNome(bimestreId: number): string {
    const bimestre = this.bimestres.find(b => b.id === bimestreId);
    return bimestre ? bimestre.name : 'N/A';
  }

}
